import React, { useState, useEffect } from "react";
import Layout from "../components/Layout";
import { useLang } from "../utils/LangContext";

const MobileRequirements = () => {
  const { t } = useLang();

  const [checks, setChecks] = useState({
    isMobile: false,
    isAndroid: false,
    isiOS: false,
    hasGeolocation: false,
    gpsEnabled: false,
    hasMotionSensors: false,
    hasStorageAccess: false,
    hasCookieAccess: false,
    onlineStatus: navigator.onLine,
    hasCameraPermission: false,
  });

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isAndroid = /android/i.test(userAgent);
    const isiOS = /iPhone|iPad|iPod/i.test(userAgent);

    const checkGeolocation = () => {
      if ("geolocation" in navigator) {
        setChecks((prev) => ({ ...prev, hasGeolocation: true }));
        navigator.geolocation.getCurrentPosition(
          () => setChecks((prev) => ({ ...prev, gpsEnabled: true })),
          () => setChecks((prev) => ({ ...prev, gpsEnabled: false }))
        );
      }
    };

    const checkMotionSensors = () => {
      if ("DeviceMotionEvent" in window || "DeviceOrientationEvent" in window) {
        setChecks((prev) => ({ ...prev, hasMotionSensors: true }));
      }
    };

    const checkStorageAccess = () => {
      try {
        localStorage.setItem("test", "test");
        localStorage.removeItem("test");
        setChecks((prev) => ({ ...prev, hasStorageAccess: true }));
      } catch (e) {
        setChecks((prev) => ({ ...prev, hasStorageAccess: false }));
      }
    };

    const checkCookieAccess = () => {
      document.cookie = "test=1";
      setChecks((prev) => ({ ...prev, hasCookieAccess: document.cookie.includes("test=1") }));
    };

    const checkCamera = async () => {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true });
        setChecks((prev) => ({
          ...prev,
          hasCameraPermission: true,
        }));
        stream.getTracks().forEach((track) => track.stop());
      } catch (error) {
        setChecks((prev) => ({
          ...prev,
          hasCameraPermission: false,
        }));
      }
    };

    setChecks((prev) => ({
      ...prev,
      isMobile: isAndroid || isiOS,
      isAndroid,
      isiOS,
    }));

    checkGeolocation();
    checkMotionSensors();
    checkStorageAccess();
    checkCookieAccess();
    checkCamera();

    window.addEventListener("online", () => setChecks((prev) => ({ ...prev, onlineStatus: true })));
    window.addEventListener("offline", () => setChecks((prev) => ({ ...prev, onlineStatus: false })));

    return () => {
      window.removeEventListener("online", () => {});
      window.removeEventListener("offline", () => {});
    };
  }, []);

  return (
    <Layout>
      <div>
        <h2>{t("Check mobile requirements")}</h2>
        <ul>
          <li>
            {t("Mobile OS")}:{" "}
            {checks.isMobile
              ? checks.isAndroid
                ? "✅ Yes, Android"
                : checks.isiOS
                ? "✅ Yes, iOS"
                : "❌ Unknown OS"
              : "-"}
          </li>
          <li>{t("Geolocation Supported")}: {checks.hasGeolocation ? "✅ Yes" : "❌ No"}</li>
          <li>{t("GPS Enabled")}: {checks.gpsEnabled ? "✅ Yes" : "❌ No"}</li>
          <li>{t("Motion Sensors Available")}: {checks.hasMotionSensors ? "✅ Yes" : "❌ No"}</li>
          <li>{t("Storage Access")}: {checks.hasStorageAccess ? "✅ Yes" : "❌ No"}</li>
          <li>{t("Cookies Enabled")}: {checks.hasCookieAccess ? "✅ Yes" : "❌ No"}</li>
          <li>{t("Online Status")}: {checks.onlineStatus ? "✅ Online" : "❌ Offline"}</li>
          <li>{t("Camera Permission")}: {checks.hasCameraPermission ? "✅ Granted" : "❌ Denied"}</li>
        </ul>
      </div>
    </Layout>
  );
};

export default MobileRequirements;
